module.exports = __webpack_public_path__ + "static/media/4-_DSC0673.72249062.jpg";